import React from 'react';
import { usePendingApprovalRequestToMeQuery } from '../../../__generated__/graphql';
import ServerError from '../../../../../components/ServerError';
import { mapApprovalRequests } from '../ApprovalRequestsTable/mappings';
import { ApprovalRequestsTable } from '../ApprovalRequestsTable/ApprovalRequestsTable';

export const PendingApprovalRequests: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { data, loading, error } = usePendingApprovalRequestToMeQuery();

  if (error) {
    return <ServerError />;
  }

  const requests = mapApprovalRequests(data?.me.approvalRequests ?? []);

  return <ApprovalRequestsTable requests={requests} loading={loading} />;
};
